import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { TableData } from "@shared/model/auction.model";
import { VVehicleAuction } from "@shared/model/vehicle.model";
import { VehicleService } from "@shared/services/vehicle/vehicle.service";

@Component({
	selector: "app-vehicle-auctions-dialog",
	templateUrl: "./vehicle-auctions-dialog.component.html",
	styleUrl: "./vehicle-auctions-dialog.component.scss",
	standalone: false
})
export class VehicleAuctionsDialogComponent implements OnInit {
	auctions: VVehicleAuction[];
	defaultLimit = 30;
	defaultOffset = 0;
	tableData: TableData = {
		rowsOnPage: 10,
		orderBy: "dateCreate",
		sortOrder: "desc",
		offset: this.defaultOffset,
		limit: this.defaultLimit,
		col: 4
	};
	rowsOnPageSet = [10, 20, 30];
	protected Math = Math;

	constructor(
		public dialogRef: MatDialogRef<VehicleAuctionsDialogComponent>,
		private vehicleService: VehicleService,
		@Inject(MAT_DIALOG_DATA) public data: number
	) { }

	/* onNoClick(): void {
		this.dialogRef.close();
	} */

	ngOnInit(): void {
		this.vehicleService.getVehicleInAuctionDetailUsingGET(this.data).subscribe(value => {
			this.auctions = value;
		});
	}

	close() {
		this.dialogRef.close();
	}
}